import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseService } from "src/app/base/services/base.service";
import { ExportarDropbox } from "../models/exportar-dropbox.model";
import { Observable } from "rxjs";

@Injectable()
export class ExportarDropboxService extends BaseService<ExportarDropbox>{

  constructor(public http: HttpClient) {
    super(http);
  }

  public getPathModule(): string {
    return '/projetos/exportar-dropbox';
  }

  public listExportTypes(): Observable<any> | any {
    return this.http.get<any>(this.baseUrl + "/list-export-type", { headers: this.headers });
  }

  public listExecution(): Observable<any> | any {
    return this.http.get<any>(this.baseUrl + "/list-execution", { headers: this.headers });
  }

}